// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Switch';



// WEBPACK FOOTER //
// ./components/Switch/index.js